module.exports = __webpack_public_path__ + "static/media/tti_promotion_title.89b075ec.png";